/*
 * @FilePath     : /fe-estrain-customer/src/common/crypto.js
 * @Author       : LiYang
 * @Date         : 2021-12-05 14:24:16
 * @LastEditTime : 2021-12-05 15:04:25
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */
import CryptoJS from 'crypto-js';

export const SECRETKEY = 'EA929643C5FF10E79BEDA292A931F9E1';
const keyHex = CryptoJS.enc.Utf8.parse(SECRETKEY);

// 加密
export const AES_ECB_ENCRYPT = (text) => {
  const messageHex = CryptoJS.enc.Utf8.parse(text);
  const encrypted = CryptoJS.AES.encrypt(messageHex, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

// 解密
export const AES_ECB_DECRYPT = (text) => {
  const decrypt = CryptoJS.AES.decrypt(text, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt);
};

// 根据自定义key加密
export const AES_ECB_ENCRYPT_BY_KEY = (text, curKey) => {
  const keyHex = CryptoJS.enc.Utf8.parse(curKey);
  const messageHex = CryptoJS.enc.Utf8.parse(text);
  const encrypted = CryptoJS.AES.encrypt(messageHex, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

// 根据自定义key解密
export const AES_ECB_DECRYPT_BY_KEY = (text, curKey) => {
  const keyHex = CryptoJS.enc.Utf8.parse(curKey);
  const decrypt = CryptoJS.AES.decrypt(text, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt);
};